import React from 'react';

// intl imports
import { FormattedMessage, useIntl, FormattedDate } from 'react-intl';

// material-ui imports
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid
} from '@material-ui/core';

// internal UI components
import { Value, Caption } from '../workOrderDetails'
import { useEntryStyle } from './RelatedWork';
import moment from 'moment';


const useStyles = makeStyles({
    root: {
        flexGrow: 1
    },
    gridItem: {
        padding: '6px !important'
    },
    divtext: {
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap'
    }
});

const LocateRow = (props) => {
    const { locate } = props;
    const classes = Object.assign(useStyles(), useEntryStyle());
    const formatDate = (params) => {
        if(typeof params === "object"){
           return params ? moment(params).format('MMM DD, YYYY') : ""
        }
       return params ? moment.utc(params).format('MMM DD, YYYY') : ""
    }
    return (
        <Grid className={classes.entryContainer + ' ' + classes.entrySpacing} item xs={12}>
            <Grid container spacing={1}>
                <Grid item md className={classes.gridItem}>
                    <Caption>
                        <FormattedMessage
                            id='admin.work-order-details.locate-list.locate-number-col-header'
                            defaultMessage='Locate number'
                            description='Admin work order locate number column header'
                        />
                    </Caption>
                    <Value>{locate.locateNumber}</Value>
                </Grid>
                <Grid item md className={classes.gridItem}>
                    <Caption>
                        <FormattedMessage
                            id='admin.work-order-details.locate-list.requested-date-col-header'
                            defaultMessage='Requested'
                            description='Admin work order Locate list Requested Date column header'
                        />
                    </Caption>
                    <Value>{formatDate(locate.requestedDate)}</Value>
                </Grid>
                <Grid item md className={classes.gridItem}>
                    <Caption>
                        <FormattedMessage
                            id='admin.work-order-details.locate-list.received-date-col-header'
                            defaultMessage='Received'
                            description='Admin work order locate list received date column header'
                        />
                    </Caption>
                    <Value>
                    {formatDate(locate.receivedDate)}
                    </Value>
                </Grid>
                <Grid item md className={classes.gridItem}>
                    <Caption>
                        <FormattedMessage
                            id='admin.work-order-details.locate-list.expires-date-col-header'
                            defaultMessage='Expires'
                            description='Admin work order locate list Expires date column header'
                        />
                    </Caption>
                    <Value>{formatDate(locate.expirationDate)}</Value>
                </Grid>
                <Grid item xs={12} className={classes.gridItem}>
                    <Caption>
                        <FormattedMessage
                            id='admin.work-order-details.locate-list.comment-col-header'
                            defaultMessage='Comment'
                            description='Admin work order locate list Comment column header'
                        />
                    </Caption>
                    <div className={classes.divtext}>{locate.comment}</div>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default LocateRow;